class SdkEmulator {
  constructor () {
    this.achievements = [];
    this.analytics = {
      trackGameStart: function () { },
      trackGameTitle: function () { },
      trackGamePause: function () { },
      trackPlay: function () { }
    };
    this.state = { musicOn: true, soundsOn: true };
    this.highScore = 0;
    // this.highScore = 1000;
  }
  getGameState () {
    // console.log('SdkEmulator.getGameState', this.state);
    return new Promise((resolve, reject) => {
      resolve(this.state);
    });
  }
  setGameState (state) {
    this.state = state;
    // console.log('SdkEmulator.setGameState', state);
  }
  setHighScore (score) {
    this.highScore = score;
    // console.log('SdkEmulator.setHighScore', score);
    return new Promise((resolve, reject) => {
      resolve();
    });
  }
  getHighScore () {
    // console.log('SdkEmulator.getHighScore', this.highScore);
    return new Promise((resolve, reject) => {
      resolve(this.highScore);
    });
  }
  showAd () {
    // console.log('SdkEmulator.showAd');
    return new Promise((resolve, reject) => {
      resolve();
    });
  }
  debug (log) {
    // console.log('SDK Emulator Log:', log);
  }
  setPauseFunction () { }
  setPlayFunction () { }
}

module.exports = SdkEmulator;
